import { render } from "./dm_timeline.vue?vue&type=template&id=294f8b6d"
import script from "./dm_timeline.js?vue&type=script&lang=js"
export * from "./dm_timeline.js?vue&type=script&lang=js"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__